export const INFINITE_SCROLL_QUERY_THRESHOLD = 85;
export const MAX_MODAL_WIDTH = '552px';
export const DEFAULT_BOTTOM_SHEET_HEIGHT = 700;
